import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ssg-vertical-progress-step',
  templateUrl: './vertical-progress-step.component.html',
  styleUrls: ['./vertical-progress-step.component.less']
})
export class VerticalProgressStepComponent {
  stateChanged = new EventEmitter<any>();
  extendToNextStep = false;
  isLast = false;

  private _inProgress = false;
  private _complete = false;

  @Input() usePsgStyle = false;

  get inProgress(): boolean {
    return this._inProgress;
  }

  @Input() set inProgress(value: boolean) {
    if (value === this._inProgress) {
      return;
    }

    this._inProgress = value;
    this.stateChanged.emit();
  }

  get complete(): boolean {
    return this._complete;
  }

  @Input() set complete(value: boolean) {
    if (value === this._complete) {
      return;
    }

    this._complete = value;
    this.stateChanged.emit();
  }

  constructor() { }
}
